import { render, staticRenderFns } from "./distributionBatch.vue?vue&type=template&id=0f00dfe9&scoped=true"
import script from "./distributionBatch.vue?vue&type=script&lang=js"
export * from "./distributionBatch.vue?vue&type=script&lang=js"
import style0 from "./distributionBatch.vue?vue&type=style&index=0&id=0f00dfe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f00dfe9",
  null
  
)

export default component.exports